// Polyfills - These MUST be the first imports and the order does matter
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fastestsmallesttextencoderdecoder';

import * as React from 'react';
import { createRoot } from 'react-dom/client';
import '@manulife/mux-tokens/fonts/fonts.css';
import '@manulife/mux/styles/reset.css';
import '@manulife/mux/styles/index.css';
import './assets/styles/global.css';
import App from './app';
import client from './restClients/authenticatedBff';

client.get('init-session').then(({ data: { csrfToken } }) => {
  client.defaults.headers['X-CSRF-TOKEN'] = csrfToken;

  const container = document.getElementById('app');
  if (!container) {
    throw new Error("Root element with id 'app' not found. Ensure your HTML contains a div with id='app'");
  }
  const root = createRoot(container);

  const render = (RootComponent) => {
    root.render(<RootComponent />);
  };

  render(App);

  if (module.hot) {
    module.hot.accept('./app', () => {
      // eslint-disable-next-line global-require
      const NewApp = require('./app').default;

      render(NewApp);
    });
  }
});
